/** Shared blue backdrop used behind marketing feature visuals. */
export function MarketingVisualBackdrop() {
  return (
    <div
      aria-hidden
      className="marketing-visual-backdrop absolute inset-0"
    />
  );
}
